import React from 'react';
import s from './Nav.module.css';
import { NavLink } from 'react-router-dom';

const Nav = (props) => {
    return (
        <nav className={s.nav}>
                <NavLink className={s.link} to={props.link}><div className={s.back}></div></NavLink>
                <span className={s.title}>{props.name}</span>
        </nav>
    )
}

export default Nav;